import React from "react";
import { logout } from "wasp/client/auth";
import MenuItem from "../components/MenuItem";
import { deleteUserByIdDev, useQuery } from "wasp/client/operations";
import { useDebugMode } from "../shared/hooks";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../store/store";
import { HousePlus, ArrowRightLeft } from "lucide-react";
import { getAllCollectionsOfUser } from "wasp/client/operations";
import { GetAllCollectionsOfUserOutput } from "../admin/dashboards/operations";
import { setIsAddStoreDialogOpen, setSwitchStoreDialogOpen } from "../store/flowSlice";
import { analytics } from "../analytics";
import { useTranslation } from "react-i18next";

export const UserMenuItems = ({
  setMobileMenuOpen,
}: {
  setMobileMenuOpen?: (open: boolean) => void;
}): React.JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isDebugMode = useDebugMode();
  const {currentUser, currentCollection} = useSelector((state: RootState) => state.user);
  const handleMobileMenuClick = () => {
    if (setMobileMenuOpen) setMobileMenuOpen(false);
  };

  const { data: collections, isLoading: collectionsLoading } = useQuery(
    getAllCollectionsOfUser
  );
  const hasMultipleCollections =  collections && (collections as GetAllCollectionsOfUserOutput[]).length > 1 ? true : false;

  const handleDeleteUser = async (): Promise<void> => {
    if (
      confirm(
        t('header.delete_user_confirm')
      )
    ) {
      if (currentUser?.id) {
        await deleteUserByIdDev({ id: currentUser?.id });
        localStorage.clear();
        logout();
      }
    }
  };


  return (
    <>
      <div className="absolute right-0 h-2 top-full" />
      <div className="absolute right-0 top-[-12px]  md:top-[calc(100%+8px)] w-48 bg-white rounded shadow-lg">
        <div className="py-1 px-3 border-b">
          <div className="text-sm py-1">{currentUser?.email}</div>
        </div>

        {currentCollection?.collection?.miqImportMethod && (
          <button
          onClick={()=>{
            dispatch(setIsAddStoreDialogOpen(true))
          }}
          className="w-full font-semibold text-blue-700 flex items-center justify-between px-3 py-1.5 text-sm hover:bg-gray-50 text-left cursor-pointer">
            {t('header.add_store')}
            <HousePlus className="mr-2 h-4 w-4" />
          </button>
        )}

        {hasMultipleCollections && (
          <button
          onClick={()=>{
            dispatch(setSwitchStoreDialogOpen(true))
          }}
          className="w-full bg-orange-50 text-orange-700 flex items-center justify-between px-3 py-1.5 text-sm hover:bg-gray-50 text-left cursor-pointer">
            {t('header.switch_store')}
            <ArrowRightLeft className="mr-2 h-4 w-4" />
          </button>
        )}

        <div className="py-1">
          <MenuItem className="w-full px-3 py-1.5 text-sm hover:bg-gray-50 text-left cursor-pointer">
            {t('header.billing')}
          </MenuItem>

          <a
            href="https://www.marketplaceiq.io/docs-category/releases/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleMobileMenuClick}
            className="flex w-full px-3 py-1.5 text-sm hover:bg-gray-50"
          >
            <div className="flex justify-between w-full items-center">
              <span>{t('header.product_releases')}</span>
              <span className="text-blue-600 text-xs">{t('header.new_tag')}</span>
            </div>
          </a>

          <button
            onClick={() => {
              analytics.sendLogoutEvent({
                email: currentUser!.email ?? currentUser!.id ?? "unknown",
              });
              logout();
            }}
            className="w-full px-3 py-1.5 text-sm hover:bg-gray-50 text-left cursor-pointer"
          >
            {t('header.logout')}
          </button>

          {isDebugMode && (
            <button
              onClick={handleDeleteUser}
              data-testid="delete-user-button"
              className="w-full px-3 py-1.5 text-sm text-red-500 font-bold hover:bg-red-50 text-left cursor-pointer border-t"
            >
              <b>!!</b>DEL. USER<b>!!</b>
            </button>
          )}
          {/* {isDebugMode && (
            <button
              onClick={handleDeleteUserData}
              className="w-full px-3 py-1.5 text-sm text-red-500 font-bold hover:bg-red-50 text-left cursor-pointer border-t"
            >
              <b>!!</b>DEL. USER DATA<b>!!</b>
            </button>
          )} */}
        </div>
      </div>
    </>
  );
};

export default UserMenuItems;
